<template>
    <div class="hidden lg:block w-next-nav fixed h-menu bg-next-dark-gray z-10">
        <div class="grid grid-rows-7 h-full">
            <MenuButton :to="{name:'HomePermessi'}" icon-class="icon-home"></MenuButton>
            <div class="flex-grow grid grid-rows-6 row-span-6 text-center">
                <MenuButton :to="{name:'ListaUtenti'}" tooltip="Utenti"><span class="text_vertical">Utenti</span></MenuButton>
                <MenuButton :to="{name:'ListaRuoli'}" tooltip="Ruoli"><span class="text_vertical">Ruoli</span></MenuButton>
                <MenuButton :to="{name:'ListaPermessi'}" tooltip="Permessi"><span class="text_vertical">Perme.</span></MenuButton>
                <MenuButton :to="{name:'ListaAziendeGruppo'}" tooltip="Aziende gruppo"><span class="text_vertical">Az. Gruppo</span></MenuButton>
                <MenuButton :to="{name:'BusinessUnits'}" tooltip="Business Unit"><span class="text_vertical">Bu</span></MenuButton>
                <ProfileMenuButton class="row-start-6" :notification="meCounters?.notification_counter > 0"></ProfileMenuButton>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import MenuButton from "@/components/MenuButton.vue";
import ProfileMenuButton from "@/components/ProfileMenuButton.vue";
import { mapGetters } from 'vuex';

@Options({
    name:'PermessiMenu',
    components:{
        MenuButton,
        ProfileMenuButton
    },
    props: {
        type: {
            type: Number,
            default: 0
        },
        id: String
    },
    computed: {
        ...mapGetters([
            'meCounters',
        ]),
    },
})
export default class PermessiMenu extends Vue {
    private $store: any;

    toggle() {
        this.$store.commit('toggle_menu')
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.text_vertical{
    //writing-mode: vertical-rl;
    //text-orientation: upright;
    font-size: 12px;
    //position: absolute;
}
</style>
